// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"a6b770e4","486":"3abe3719","873":"1f6b221a","902":"a7e8d9b2"}[chunkId] + ".chunk.js";
};